import { type GradeWithLessons } from "@core/grades/types";
import { URLS } from "@core/shared/utils";
import { Carousel } from "@design-system/components/Carousel/Carousel";
import { BaseLink } from "@design-system/components/link";
import { cn } from "@design-system/lib/utils";
import { useIsRTL } from "@framework/shared/hooks";
import { trans } from "@mongez/localization";
import { ArrowRightIcon, GraduationCapIcon } from "lucide-react";
import { LessonCard } from "./LessonCard";

type GradesCarouselProps = {
  grade: GradeWithLessons;
  className?: string;
};

export function GradesCarousel({ grade, className }: GradesCarouselProps) {
  const isRTL = useIsRTL();
  if (!grade.lessonsList?.length) return null;

  return (
    <section className={className}>
      <div className="mb-4 flex flex-col gap-3 border-b border-gray-200 dark:border-gray-700 pb-3 sm:mb-6 sm:flex-row sm:items-center sm:justify-between sm:gap-0">
        <div className="flex items-center gap-2">
          <GraduationCapIcon className="h-5 w-5 text-primary-600 dark:text-primary-400 sm:h-6 sm:w-6" />
          <h2 className="font-heading text-lg font-bold text-gray-900 dark:text-gray-100 sm:text-xl lg:text-2xl">
            {grade.name}
          </h2>
        </div>
        <BaseLink
          to={URLS.grades.view(grade)}
          className="flex w-fit items-center gap-1 text-xs font-medium text-primary-600 dark:text-primary-400 transition-colors hover:text-primary-700 dark:hover:text-primary-300 sm:text-sm"
        >
          {trans("viewMore")}
          <ArrowRightIcon className={cn("size-3", isRTL && "rotate-180", "sm:size-4")} />
        </BaseLink>
      </div>
      <Carousel slidesPerView={3}>
        {grade.lessonsList.map((lesson) => (
          <LessonCard key={lesson.id} lesson={lesson} />
        ))}
      </Carousel>
    </section>
  );
}
